export interface TabInfo {
  path: string;
  title: string;
  // type: string;
  // collapse?: string;
  // icontype: string;
  // icon: string;
}
export const TABS_PEOPLE: TabInfo[] = [
   {
    path: "administration/people/users",
    title: "menuItems.users",
  }, 
  {
    path: "administration/people/groups",
    title: "menuItems.groups",
  },
  {
    path: "administration/people/roles",
    title: "menuItems.roles",
  },
];
